import { render, staticRenderFns } from "./DistributorDetail.vue?vue&type=template&id=db7c4a78"
import script from "./DistributorDetail.vue?vue&type=script&lang=js"
export * from "./DistributorDetail.vue?vue&type=script&lang=js"
import style0 from "./DistributorDetail.vue?vue&type=style&index=0&id=db7c4a78&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports